import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'License';

const getLicenses = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data; // Expect the API to return a boolean isValid
    } catch (error) {
        console.error('License validation failed', error);
        throw error;
    }
}

// Get a specific configuration by name
const addLicense = async (licenseKey, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add`, { licenseKey } , {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Failed to fetch configuration:', error);
        return error.response;
    }
};

// Assign a license to a user
const assignLicenseToUser = async (hash, accessType, userContactName, userContactEmail, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/assign`, {
            hash,
            accessType,
            userContactName,
            userContactEmail
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Failed to assign license:', error);
        return error.response;
    }
};


const validateLicense = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/validate`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response; // Expect the API to return a boolean isValid
    } catch (error) {
        console.error('License validation failed', error);
        return error.response;
    }
}

export const LicenseDataService = {
    addLicense,
    validateLicense,
    getLicenses,
    assignLicenseToUser
};